var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWhitev3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512px",
    height: "512px",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.993
    },
    fill: "#131313",
    d: "M 231.5,10.5 C 328.304,5.00172 404.804,41.3351 461,119.5C 506.581,191.924 514.247,268.258 484,348.5C 444.553,436.916 376.72,487.75 280.5,501C 196.702,506.858 126.536,479.025 70,417.5C 13.2687,347.853 -3.06463,269.52 21,182.5C 47.6733,103.16 100.507,49.6601 179.5,22C 196.666,16.8028 214,12.9694 231.5,10.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#32fd98",
    d: "M 255.5,41.5 C 295.976,105.102 336.476,168.769 377,232.5C 377.688,233.332 377.521,233.998 376.5,234.5C 336.392,216.363 296.226,198.363 256,180.5C 214.661,197.42 173.494,214.753 132.5,232.5C 132.167,232.167 131.833,231.833 131.5,231.5C 173.279,168.401 214.612,105.068 255.5,41.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#32fd98",
    d: "M 254.5,206.5 C 258.325,207.074 261.991,208.241 265.5,210C 304.833,227.667 344.167,245.333 383.5,263C 341.167,286.833 298.833,310.667 256.5,334.5C 213.167,310.167 169.833,285.833 126.5,261.5C 169.226,243.133 211.893,224.799 254.5,206.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#32fc97",
    d: "M 258.5,467.5 C 257.833,467.5 257.167,467.5 256.5,467.5C 215.219,409.712 173.719,352.045 132,294.5C 131.312,293.668 131.479,293.002 132.5,292.5C 173.437,316.885 214.603,340.885 256,364.5C 297.061,341.72 337.894,318.553 378.5,295C 380.402,293.699 382.402,293.032 384.5,293C 342.282,351.045 300.282,409.212 258.5,467.5 Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1
    },
    fill: "#228151",
    d: "M 256.5,467.5 C 257.167,467.5 257.833,467.5 258.5,467.5C 257.833,470.167 257.167,470.167 256.5,467.5 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhitev3);
export default __webpack_public_path__ + "static/media/whitev3.67ffe213d11881cf5207427430ad9157.svg";
export { ForwardRef as ReactComponent };